import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useMe } from '@/features/auth/useAuth';
import { AuthProvider } from '@/lib/auth-context';

/**
 * Layout route that gates the AppShell behind a resolved user.
 *
 * - While `useMe()` is loading on first hit, show a neutral splash so we
 *   never paint the login form for half a frame when the user is already
 *   signed in.
 * - 401 (resolved as `data: null`) redirects to `/login`, preserving the
 *   attempted location so the eventual return-to-flow can read it.
 */
export const RequireAuth = () => {
  const me = useMe();
  const location = useLocation();

  if (me.isLoading) {
    return (
      <div
        className="flex h-screen w-full items-center justify-center bg-efs-bg-app text-sm text-efs-text-muted"
        role="status"
      >
        <span>…</span>
      </div>
    );
  }

  if (!me.data) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <AuthProvider user={me.data} isLoading={false}>
      <Outlet />
    </AuthProvider>
  );
};

export default RequireAuth;
